import { attachFilesForSelectedAction } from './helpers/attachFilesForSelectedAction';
import createFilePickerUserConfiguration from './helpers/configuration/createFilePickerUserConfiguration';
import type { CreateAttachmentHandler } from '../types/CreateAttachmentHandler';
import type { InsertLinkHandler } from '../types/InsertLinkHandler';
import { FilePickerConfiguration, FilePickerResult, lazyFilePicker } from 'owa-filepicker';
import * as trace from 'owa-trace';

export default async function attachmentFilePicker(
    createAttachmentHandler: CreateAttachmentHandler | null,
    insertLinkHandler: InsertLinkHandler | null,
    filePickerConfiguration: FilePickerConfiguration
) {
    const filePicker = await lazyFilePicker.import();
    if (!filePickerConfiguration.userConfiguration) {
        filePickerConfiguration.userConfiguration = createFilePickerUserConfiguration();
    }

    try {
        return filePicker(filePickerConfiguration)
            .then((result: FilePickerResult) => {
                attachFilesForSelectedAction(
                    createAttachmentHandler,
                    insertLinkHandler,
                    result.files,
                    result.source,
                    result.action,
                    result.supportsInsertLink,
                    filePickerConfiguration.targetWindow,
                    false /* treatShareAsInsertLink */
                );
            })
            .catch(() => {
                // No files were selected
            });
    } catch (error) {
        trace.errorThatWillCauseAlert(
            'Error creating the file picker. Attaching or sharing files might not work! ' + error
        );
    }
}
